import instance from '@apis/instance';
import { GetNoticesParams, NoticeDetail, NoticeRow } from '@models/notice';
import { PageResponse } from '@models/page';

class NoticeApi {
    static getNotices(params: GetNoticesParams): Promise<PageResponse<NoticeRow>> {
        return instance.get('/v0/notices', { params });
    }

    static getNotice(id: string): Promise<NoticeDetail> {
        return instance.get(`/v0/notices/${id}`);
    }
}

export default NoticeApi;
